import dayjs from "dayjs";
import { isVoid } from "@/shared/utils";
import { NoteStatuses, type CalendarControllerResponse } from "@/services/api";
import type { Dayjs } from "dayjs";
import { formatSDate } from "./format-s-date";

export const getCurrentDayEvents = (currentDate: Dayjs, events?: CalendarControllerResponse) => {
  if (isVoid(events)) {
    return {
      birthdays: [],
      anniversaries: [],
      notes: [],
    };
  }

  const formattedDate = currentDate.format("YYYY-MM-DD");

  return {
    birthdays: events.birthdays.filter((event) => {
      const eventDate = formatSDate(event.date, currentDate);
      return eventDate === formattedDate;
    }),
    anniversaries: events.anniversaries.filter((event) => {
      const eventDate = formatSDate(event.date, currentDate);
      return eventDate === formattedDate;
    }),
    notes: events.notes
      .filter(
        (event) =>
          dayjs(event.date).format("YYYY-MM-DD") === formattedDate &&
          (([NoteStatuses.DONE].includes(event.status) && event.important) || !event.important),
      )
      .sort(
        (a, b) => Number(a.status === NoteStatuses.DONE) - Number(b.status === NoteStatuses.DONE),
      ),
    importantNotes: events.notes.filter(
      (event) =>
        dayjs(event.date).format("YYYY-MM-DD") === formattedDate &&
        event.important &&
        [NoteStatuses.TO_DO, NoteStatuses.IN_PROGRESS].includes(event.status),
    ),
  };
};
